import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import React, {useEffect} from "react";
import {
  currentlyEditingSleeperSelector,
  setCurrentStepDoubleSleeperMattressBuilder,
  setCurrentlyEditingSleeper, checkErrorsSelector,
} from "../../../../redux/slices/customNavigation";
import {
  mattressConfigurationSelector, primarySleeperPrimarySleepStyleSelector,
  updateMattressConfiguration,
} from "../../../../redux/slices/mattressConfiguration";
import {
  metaFieldIdSelector,
  shopifyCustomerSelector,
} from "../../../../redux/slices/customer";
import BackgroundStepNumber from "../../SingleBedBuilder/common/BackgroundStepNumber";
import BedBuilderHeader from "../../SingleBedBuilder/common/BedBuilderHeader";
import BedBuilderNextButton from "../../SingleBedBuilder/common/BedBuilderNextButton";
import BodyTypeRadioGroup from "../../SingleBedBuilder/HeightAndWeight/BodyTypeRadioGroup";
import EvrbedSwitch from "../../../../components/Switch/EvrbedSwitch";
import SleepStyles from "../../SingleBedBuilder/SleepStyle/SleepStyles";
import SleeperSelectorButtons from "../common/SleeperSelectorButtons";
import UnitInput from "../../../../components/Inputs/UnitInput";

import styled from "styled-components";
import {saveMattressConfigurationToLocalStorage} from "../../../../utils/bedBuilder.utils";

const StyledContentContainer = styled.div`
  position: relative;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const StyledSettingsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const StyledHeightWeightContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledInputLabel = styled.div`
  font-family: noto-sans;
`;

const StyledContainer = styled.div`
  position: absolute;
  left: 0;
  //top: 35%;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const StyledSleeperButtonsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 17%;
  height: 100%;
  padding-top: 20%;
  z-index: 20;
`;

const StyledRawContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 83%;
  height: 100%;
  padding-top: 17vh;
`;

const StyledSleeperSelectContainer = styled.div``;

const DoubleSleeperSleepStyle = ({ currentStep }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;
  const shopifyCustomer = useSelector(shopifyCustomerSelector);
  const metaFieldId = useSelector(metaFieldIdSelector);
  const mattressConfiguration = useSelector(mattressConfigurationSelector);
  const primarySleeperPrimarySleepStyle = useSelector(
    primarySleeperPrimarySleepStyleSelector
  );
  const primarySleeperSecondarySleepStyle = useSelector(
    state => state.mattressConfiguration.mattressBuilder.primarySleeper.secondarySleepStyle
  );
  const secondarySleeperPrimarySleepStyle = useSelector(
    state => state.mattressConfiguration.mattressBuilder.secondarySleeper.primarySleepStyle

  );
  const secondarySleeperSecondarySleepStyle = useSelector(
    state => state.mattressConfiguration.mattressBuilder.secondarySleeper.secondarySleepStyle
  );
  const checkErrors = useSelector(checkErrorsSelector);


  const handleUpdateMattressConfiguration = () => {
    const newMattressConfiguration = {
      metaFieldId: metaFieldId,
      id: shopifyCustomer.id,
      mattressConfiguration: mattressConfiguration,
    };
    dispatch(updateMattressConfiguration(newMattressConfiguration));
  };

  const errorColor1 = (primarySleeperPrimarySleepStyle === null && checkErrors) ? "red" : theme.COLORS.BLUE.darkBlueGreen;
  const errorColor2 = (primarySleeperSecondarySleepStyle === null && checkErrors) ? "red" : theme.COLORS.BLUE.darkBlueGreen;
  const errorColor3 = (secondarySleeperPrimarySleepStyle === null && checkErrors) ? "red" : theme.COLORS.BLUE.darkBlueGreen;
  const errorColor4 = (secondarySleeperSecondarySleepStyle === null && checkErrors) ? "red" : theme.COLORS.BLUE.darkBlueGreen;

  return (
    <StyledSleeperSelectContainer>
      <StyledSleeperButtonsContainer>
        <SleeperSelectorButtons
          editingSleeper1={editingSleeper1}
        ></SleeperSelectorButtons>
        <BackgroundStepNumber
          styles={{
            marginTop: editingSleeper1 ? "-39vh" : "-21vh",
            transition: "marginTop 300ms ease-in-out 0s",
            // marginLeft: "-7vw",
          }}
        >
          {t("2")}
        </BackgroundStepNumber>
      </StyledSleeperButtonsContainer>

      <StyledRawContainer className={"sleep-style-panel"}>
        <StyledContentContainer
          style={{
            zIndex: 1000,
            borderRadius: "0 0 0 60px",
            // boxShadow: "0px 1px 2px #a2ccde",
            borderColor: "transparent",
            background:
              "transparent linear-gradient(0deg, #e1f4fd 0%,  #FFFFFF 100%) 0% 0% no-repeat padding-box",
          }}
        >
          <StyledContainer style={{ zIndex: 600 }}>
            <StyledSettingsContainer className="mx-2">
              {editingSleeper1 &&
                <BedBuilderHeader styles={{marginTop: "0.5rem", color: errorColor1}} className={"primary-sleep-style-header"}>
                  {t("What Is Your Primary Sleep Style?")}
                </BedBuilderHeader>
              }
              {!editingSleeper1 &&
                <BedBuilderHeader styles={{marginTop: "0.5rem", color: errorColor3}} className={"primary-sleep-style-header"}>
                  {t("What Is Your Primary Sleep Style?")}
                </BedBuilderHeader>
              }
              <SleepStyles
                primary
                editingSleeper1={editingSleeper1}
              ></SleepStyles>
              {editingSleeper1 &&
                <BedBuilderHeader styles={{marginTop: "0.5rem", color: errorColor2}}>
                  {t("What Is Your Secondary Sleep Style?")}
                </BedBuilderHeader>
              }
              {!editingSleeper1 &&
                <BedBuilderHeader styles={{marginTop: "0.5rem", color: errorColor4}}>
                  {t("What Is Your Secondary Sleep Style?")}
                </BedBuilderHeader>
              }
              <SleepStyles editingSleeper1={editingSleeper1}></SleepStyles>
              <BedBuilderNextButton
                styles={{
                  position: "absolute",
                  bottom: "5%",
                  right: "5%",
                }}
                onClick={() => {
                  //Update in local storage
                  // console.log("saving to local storage");
                  saveMattressConfigurationToLocalStorage(mattressConfiguration);
                  handleUpdateMattressConfiguration();
                  if (editingSleeper1) {
                    dispatch(setCurrentlyEditingSleeper(2));
                  } else {
                    dispatch(setCurrentlyEditingSleeper(1));
                    dispatch(
                      setCurrentStepDoubleSleeperMattressBuilder(
                        currentStep + 1
                      )
                    );
                  }
                }}
              ></BedBuilderNextButton>
            </StyledSettingsContainer>
          </StyledContainer>
        </StyledContentContainer>
      </StyledRawContainer>
    </StyledSleeperSelectContainer>
  );
};

export default DoubleSleeperSleepStyle;
